import { ADD_PORTLET, DELETE_PORTLET } from "./actionTypes";

export const addPortlet = (menu) => ({
  type: ADD_PORTLET,
  menu: menu,
});

export const deletePortlet = (menu) => ({
  type: DELETE_PORTLET,
  menu: menu,
});
